import React from "react";
import {
  LineTitle,
  customStyles,
  FORMAT_DATE_MOMENT,
  TYPE_TESTS,
} from "../index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Select from "react-select";
import { faPenToSquare, faPlus } from "@fortawesome/free-solid-svg-icons";
import { types } from "../../../../reducers/inventory/testReducer";
import Toggle from "react-toggle";

import {
  useDispatchTestForm,
  useTest,
  useActionsTest,
} from "../../../../context/inventory/TestFormProvider";
import "./createTest.css";
import Moment from "react-moment";
import Observations from "./tabs/Observations";
import Document from "./tabs/Document";
import Items from "./tabs/Items";
import Versions from "./tabs/Versions";

const CreateTest = () => {
  const dispatchTestForm = useDispatchTestForm();
  const state = useTest();
  const actions = useActionsTest();

  const {
    description,
    name,
    id,
    created_at,
    version,
    type,
    is_active,
    reference,
    parent_id,
    to_edit,
  } = state.test;

  const changeInputTest = (e) => {
    dispatchTestForm({
      type: types.CHANGE_INPUT_TEST,
      payload: { name: e.target.name, value: e.target.value },
    });
  };
  return (
    <section
      style={{ height: "91vh" }}
      className="flex flex-column container-fluid"
    >
      <LineTitle title={"Gestión de pruebas"} />

      <div style={{ marginBottom: "22px", marginTop: "22px" }} className="row">
        <div className="form-group col">
          <label> &nbsp;</label>
          <div className="font1">kit de pruebas/ensayos</div>
        </div>
        <div className="form-group   col-md-1 col-lg-1">
          <label> &nbsp;</label>
          <div disabled className="form-control">
            ID: {id}
            &nbsp;
          </div>
        </div>
        <div className="form-group col-md-1 col-lg-1">
          <label className="control-label">Fecha de creación</label>
          <div disabled className="form-control">
            &nbsp;
            <Moment format={FORMAT_DATE_MOMENT}>{created_at}</Moment>
          </div>
        </div>
        <div className="form-group col-md-2 col-lg-1">
          <label className="control-label">Referencia</label>
          <input
            type="text"
            name="reference"
            disabled={!to_edit}
            value={reference}
            onChange={(e) => changeInputTest(e)}
            className="form-control"
            placeholder="Referencia"
          />
        </div>{" "}
        <div className="form-group col-md-2 col-lg-3">
          <label className="control-label">Nombre</label>
          <input
            type="text"
            disabled={!to_edit}
            name="name"
            value={name}
            onChange={(e) => changeInputTest(e)}
            className="form-control"
            placeholder="Nombre"
          />
        </div>
        <div className="form-group col-md-3 col-lg-2">
          <label className="control-label">Seleccione tipo</label>
          <Select
            value={TYPE_TESTS.filter((w) => w.code === type)}
            placeholder="Seleccione tipo"
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.code}
            options={TYPE_TESTS}
            isDisabled={!to_edit}
            styles={customStyles}
            onChange={(e) =>
              dispatchTestForm({
                type: types.CHANGE_INPUT_TEST,
                payload: { name: "type", value: e ? e.code : null },
              })
            }
          />
        </div>
        <div className="flex-column   form-group col-md-3 col-lg-2">
          <label className="control-label">Activa</label>
          <Toggle
            disabled={!to_edit}
            onChange={(e) =>
              dispatchTestForm({
                type: types.CHANGE_INPUT_TEST,
                payload: { name: "is_active", value: e.target.checked },
              })
            }
            icons={false}
            checked={is_active}
          />
        </div>
      </div>
      <section className="form-create-test form-create-test">
        <div className="flex">
          <div className="form-group   col-md-4 col-lg-4">
            <label className=" control-label">Descripción</label>&nbsp;
            <input
              disabled={!to_edit}
              onChange={(e) => changeInputTest(e)}
              value={description}
              type="text"
              name="description"
              className="form-control"
            />
          </div>
          <div style={{marginLeft:"7px"}} className="form-group ">
            <label className="control-label">&nbsp;</label>
            <div
              onClick={() => {
                to_edit
                  ? actions.createTest()
                  : dispatchTestForm({
                      type: types.CHANGE_INPUT_TEST,
                      payload: { name: "to_edit", value: !to_edit },
                    });
              }}
              className="btn-default"
            >
              <FontAwesomeIcon
                className="margin-auto"
                icon={id ? faPenToSquare : faPlus}
              />
              &nbsp;
              <span> {id ? (to_edit ? "Guardar" : "Editar") : "Crear"} </span>
            </div>
          </div>
        </div>
      </section>
      {id && (
        <Tabs className="tabs-test-form">
          <TabList>
            <Tab>versiones de cambio del kit o solución</Tab>
          </TabList>

          <TabPanel>
            <Versions />
          </TabPanel>
        </Tabs>
      )}
    </section>
  );
};

export default CreateTest;
